import { useUnregisteredCustomerContext } from '@/views/UnregisteredCustomer/context/UnregisteredCustomerContext';

function capitalizeFirstLetter(str: string) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';
}

function formatDisplayName(firstName?: string): string {
  if (firstName?.trim()) {
    return capitalizeFirstLetter(firstName?.trim());
  }

  return '';
}

export function ExistingConfirmStep() {
  const { existingCustomer, onExistingCustomerChoice, hoverBackground, hoverHandlers, textColor } =
    useUnregisteredCustomerContext();

  if (!existingCustomer) return null;

  const displayName = formatDisplayName(existingCustomer.firstName);

  return (
    <div className='space-y-4'>
      <div>
        <h5 className='text-xl font-bold'>Hi, {displayName || 'there'}!</h5>
        <p className='mt-2 text-sm text-gray-600'>
          We noticed that you already have an account, would you like to login without entering your
          data one more time?
        </p>
      </div>

      <div className='flex flex-col gap-2'>
        <button
          onClick={() => onExistingCustomerChoice(true)}
          {...hoverHandlers}
          className='w-full cursor-pointer rounded-lg px-4 py-3 font-semibold transition-colors'
          style={{ backgroundColor: hoverBackground, color: textColor }}
        >
          Yes, use my account
        </button>
        <button
          onClick={() => onExistingCustomerChoice(false)}
          className='w-full cursor-pointer rounded-lg border border-gray-300 bg-gray-100 px-4 py-3 font-semibold transition-colors hover:bg-gray-200'
        >
          No, let me register again
        </button>
      </div>
    </div>
  );
}
